const fonts = {
  primary: {
    regular: 'Proxima Nova Regular, Verdana, Geneva, sans-serif',
    semibold: 'Proxima Nova SemiBold, Verdana, Geneva, sans-serif',
    bold: 'Proxima Nova Bold, Verdana, Geneva, sans-serif',
  },
  secondary: {
    bold: 'Kapra Regular, Arial, Helvetica, sans-serif',
    regular: 'Kapra Regular, Arial, Helvetica, sans-serif',
    optimized: 'Kapra Regular, Arial, Helvetica, sans-serif',
  },
  celebrity: {
    neutraface: 'Neutraface Text Book, Arial, Helvetica, sans-serif',
    poppins: 'Poppins Regular, Arial, Helvetica, sans-serif',
  }
};

export default fonts;
